export { default } from './TheTeam';
